<template>
  <div class="be-content" v-if="filterPeriod">
    <div class="main-content container-fluid">
      <div class="row">
        <!--Default Tabs-->
        <div class="col-sm-12">
          <div class="panel panel-default">
            <div class="panel-heading">
              <div class="row">
                <div class="col-sm-3">
                  Список нарушений c {{filterPeriod.date_start | dateFilter("DD.MM")}} по {{filterPeriod.date_end | dateFilter("DD.MM.YYYY")}}г.
                </div>
                <div class="col-sm-3 pull-right">
                  <select class="form-control input-sm" v-model="filterPeriod">
                    <option v-for="period in reportPeriods" :value="period">
                      <span>{{period.name}}</span>
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="tab-container">
              <ul class="nav nav-tabs">
                <li class="active"><a href="#reports" data-toggle="tab">Нарушение сроков сдачи отчетов</a></li>
                <li><a href="#latedata" data-toggle="tab">Нарушение сроков подачи данных о плательщиках</a></li>
              </ul>
              <div class="tab-content">
                <template v-if="dataReady">
                  <div id="reports" class="tab-pane active cont">
                    <template v-if="stats.not_submitted_reports.length>0">
                      <h4><b>Список неподтвержденных отчетов ({{stats.not_submitted_reports.length}} шт.)</b></h4>
                      <div class="row be-datatable-body">
                        <div class="col-sm-12">
                          <table class="table table-striped table-hover table-fw-widget dataTable no-footer">
                            <thead>
                            <tr>
                              <th>#</th>
                              <th>Оператор</th>
                              <th>Отчетный период</th>
                              <th>Количество записей</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="report, index in stats.not_submitted_reports">
                              <td>{{index + 1}}</td>
                              <td>
                                <router-link
                                  :to="{name:'operator-visits', params: {operatorId: report.operator}, query: {report: report.id}}">
                                  {{getOperatorNameDict(report.operator)}}
                                </router-link>
                              </td>
                              <td>
                                {{report.date_start | dateFilter('DD.MM')}} - {{report.date_end | dateFilter('DD.MM.YYYY')}}
                              </td>
                              <td>{{report.records}}</td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <hr>
                    </template>
                    <template v-if="stats.late_submitted_reports.length>0">
                      <h4>
                        <b>Список подтвержденных отчетов, с поздней датой подтверждения ({{stats.late_submitted_reports.length}} шт.)</b></h4>
                      <div class="row be-datatable-body">
                        <div class="col-sm-12">
                          <table class="table table-striped table-hover table-fw-widget dataTable no-footer">
                            <thead>
                            <tr>
                              <th>#</th>
                              <th>Оператор</th>
                              <th>Отчетный период</th>
                              <th>Дата сдачи</th>
                              <th>Количество записей</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="report, index in stats.late_submitted_reports">
                              <td>{{index + 1}}</td>
                              <td>
                                <router-link
                                  :to="{name:'operator-visits', params: {operatorId: report.operator}, query: {report: report.id}}">
                                  {{getOperatorNameDict(report.operator)}}
                                </router-link>
                              </td>
                              <td>
                                {{report.date_start | dateFilter('DD.MM')}} - {{report.date_end | dateFilter('DD.MM.YYYY')}}
                              </td>
                              <td>{{report.date_last_submit | dateFilter('DD.MM.YYYY')}}</td>
                              <td>{{report.records}}</td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </template>
                    <h4 v-if="stats.late_submitted_reports.length==0 && stats.not_submitted_reports.length==0">
                      Нарушений нет.</h4>
                  </div>
                  <div id="latedata" class="tab-pane cont">
                    <template v-if="stats.late_guest_visits_data.length>0">
                      <h4>Список плательщиков, с несвоевременной подачей данных ({{stats.late_guest_visits_data.length}})</h4>
                      <div class="row be-datatable-body">
                        <div class="col-sm-12">

                          <table class="table table-striped table-hover table-fw-widget dataTable no-footer">
                            <thead>
                            <tr>
                              <th>#</th>
                              <th>Ф.И.О</th>
                              <th>Период заезда</th>
                              <th>Дата подачи данных</th>
                              <th style="width: 50%">Оператор</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="guest_visit, index in stats.late_guest_visits_data">
                              <td>{{index + 1}}</td>
                              <td>
                                <router-link
                                  :to="{name:'operator-visits', params: {operatorId: guest_visit.operator_id}, query: {report: guest_visit.report_id}}">
                                  {{guest_visit.last_name}} {{guest_visit.first_name}} {{guest_visit.middle_name}}
                                </router-link>
                              </td>
                              <td>
                                {{guest_visit.date_start | dateFilter('DD.MM.YYYY')}} - {{guest_visit.date_end | dateFilter('DD.MM.YYYY')}}
                              </td>
                              <td>{{guest_visit.created_at | dateFilter('DD.MM.YYYY')}} </td>
                              <td>{{getOperatorNameDict(guest_visit.operator_id)}}</td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </template>
                    <h4 v-if="stats.late_guest_visits_data.length==0 ">
                      Нарушений нет.</h4>
                  </div>
                </template>
                <vue-simple-spinner v-if="!dataReady" :font-size="20"
                                    message="Формирование списка нарушений..."></vue-simple-spinner>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import momment from 'moment'

  export default {
    name: "Violations",
    data: function () {
      return {
        stats: null,
        reportPeriods: null,
        filterPeriod: null,
        dataReady: false,
        period: null,
        currentReport: null
      }
    },
    computed: {
      ...
        mapGetters(
          {
            operators: 'operators',
          }
        ),
    },
    created () {
      this.getCurrentReportPeriod()
    },
    methods: {
      getCurrentReportPeriod () {
        this.axios.get('/api/reports/current')
          .then((response) => {
            if (response.status === 200) {
              this.currentReport = response.data
              this.filterPeriod = this.currentReport
              this.getReportsPeriods()
            }
          })
      },
      getReportsPeriods () {
        this.axios.get('/api/reports/periods')
          .then((response) => {
            if (response.status === 200) {
              this.reportPeriods = response.data
            }
          })
      },
      getViolations () {
        this.dataReady = false
        this.axios.get('/api/violations', {
          params: {
            date_from: this.filterPeriod.date_start,
            date_to: this.filterPeriod.date_end
          }
        })
          .then((response) => {
            if (response.status === 200) {
              this.stats = response.data
              this.dataReady = true
            }
          })
      },
      getOperatorNameDict (id) {
        return this.operators.find(item => Number(item.id) === Number(id)).name
      }
    },
    watch: {
      filterPeriod () {
        this.getViolations()
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/dashboard/Violations.vue